module.exports = {
    "collectionLabel": `Predlozi`
};


//# sourceMappingURL=sr-SP.main.js.map
